import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCopy = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={32}
    height={32}
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M24 19.5C24 20.3284 23.3284 21 22.5 21H12.5C11.6716 21 11 20.3284 11 19.5V9.5C11 8.67157 11.6716 8 12.5 8H22.5C23.3284 8 24 8.67157 24 9.5V19.5ZM12.5 20C12.2239 20 12 19.7761 12 19.5V9.5C12 9.22386 12.2239 9 12.5 9H22.5C22.7761 9 23 9.22386 23 9.5V19.5C23 19.7761 22.7761 20 22.5 20H12.5Z'
      fill='#0062D1'
    />
    <path
      d='M9.5 23C9.22386 23 9 22.7761 9 22.5V12.5C9 12.2239 9.22386 12 9.5 12H10V11H9.5C9.32468 11 9.15639 11.0301 9 11.0854C8.4174 11.2913 8 11.8469 8 12.5V22.5C8 23.3284 8.67157 24 9.5 24H19.5C20.1531 24 20.7087 23.5826 20.9146 23C20.9699 22.8436 21 22.6753 21 22.5V22H20V22.5C20 22.7761 19.7761 23 19.5 23H9.5Z'
      fill='#0062D1'
    />
  </svg>
);
export default SvgCopy;
